import type { PublishPlatform, PublishUiStatus } from './types';

export type PublishBadgeKind = 'publishing' | 'success' | 'failed';

export type PublishBadgeCopy = {
  kind: PublishBadgeKind;
  labelKey: string;
};

export function resolvePublishBadge(
  platform: PublishPlatform,
  status: PublishUiStatus,
): PublishBadgeCopy | null {
  if (status === 'none') return null;

  if (status === 'publishing') {
    return {
      kind: 'publishing',
      labelKey: platform === 'youtube'
        ? 'publishing.badge.youtube.publishing'
        : platform === 'instagram'
          ? 'publishing.badge.instagram.publishing'
          : platform === 'facebook'
            ? 'publishing.badge.facebook.publishing'
            : 'publishing.badge.sending',
    };
  }

  if (status === 'in_drafts') {
    if (platform !== 'tiktok') return null;
    return { kind: 'success', labelKey: 'publishing.badge.inDrafts' };
  }

  if (status === 'published') {
    if (platform === 'youtube') {
      return { kind: 'success', labelKey: 'publishing.badge.youtube.published' };
    }
    if (platform === 'instagram') {
      return { kind: 'success', labelKey: 'publishing.badge.instagram.published' };
    }
    if (platform === 'facebook') {
      return { kind: 'success', labelKey: 'publishing.badge.facebook.published' };
    }
    return null;
  }

  return {
    kind: 'failed',
    labelKey: platform === 'youtube'
      ? 'publishing.badge.youtube.failed'
      : platform === 'instagram'
        ? 'publishing.badge.instagram.failed'
        : platform === 'facebook'
          ? 'publishing.badge.facebook.failed'
          : 'publishing.badge.failed',
  };
}
